import fileDownload from "js-file-download"
import { APP_VERSION } from "@fedsim/constants"

export default function useStoreExport () {
  const onExport = payload =>
    fileDownload(JSON.stringify(payload), `fedSimSave-${APP_VERSION}.json`)

  return {
    onExport,
  }
}
